import React, {Component} from 'react';
import {Link} from 'react-router-dom';
import {connect} from 'react-redux';

class AboutPage extends Component {

  componentDidMount() {

    window.scrollTo(0, 0);
  }

  render() {
    return (
      <div className="page about-page">
        <div className="container">
          <h1 className="page-title">About Us</h1>
          <div className="row">
            <div className="col-md-12">
            <p>Welcome to Jason’s Wine and Spirits!</p>

<p>Nestled in the Downtown Los Angeles Fashion District for over 40 years. We offer a wide range of beers, wines, and spirits, including unique and hard to find bottles. Whether you’re looking for that perfect gift or are just looking to unwind after a long day, you are sure to find what you need at Jason’s. Either stop by or let us deliver it to the comfort of your home or office.</p>

<p>We currently offer fast delivery 9 a.m. to 2 a.m daily, 365 days a year! Check our website to see if you are in our delivery zone or give us a call to find out. We also offer event catering throughout the greater Los Angeles area, and can send a gift delivery for that special person in your life.</p>

<p>So next time you need a drink, pick up the phone dial <a href="tel:(213) 485-WINE">(213) 485-WINE</a> or order online now at <a href="https://jasonsliquor.com">jasonsliquor.com</a></p>

<p>Cheers!</p>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default AboutPage;



// WEBPACK FOOTER //
// ./src/containers/about-us/AboutPage.js